import { ArrowRight, Loader2 } from 'lucide-react';

interface NextButtonProps {
  goToNextStep: () => void;
  disabled: boolean;
  isSubmitting?: boolean;
  next: string;
}

const NextButton = ({ goToNextStep, disabled, isSubmitting, next }: NextButtonProps) => {
  return (
    <button
      onClick={goToNextStep}
      disabled={disabled}
      className="px-6 py-3 bg-orange-600 text-white rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-orange-700 transition-colors duration-200 flex items-center gap-3">
      {isSubmitting ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin" />
          <span>Processing...</span>
        </>
      ) : (
        <>
          <span>{next}</span>
          <ArrowRight className="w-4 h-4" />
        </>
      )}
    </button>
  );
};

export default NextButton;
